import tw, { css, styled } from 'twin.macro'

import { Link } from 'gatsby'

export const HeroSection = styled.section`
	@media(min-width: 525px) {
		${tw`mb-8`}
	}
	${tw`flex flex-col w-full items-center bg-center bg-no-repeat bg-cover relative overflow-hidden mb-8`}
	background-image: url(${({ sources }) => sources[0].base64});

	video {
		transform: scale(1);
	}

	@media (min-width: 375px) {
		height: 230px;
		max-height: 230px;
		video {
			transform: scale(1.2);
		}
	}

	@media (min-width: 525px) {
		height: 290px;
		max-height: 290px;
		video {
			transform: scale(1);
		}
	}

	@media (min-width: 768px) {
		height: 430px;
		max-height: 430px;
	}

	@media (min-width: 1024px) {
		height: 570px;
		max-height: 570px;
	}
	@media (min-width: 1280px) {
		height: 720px;
		max-height: 720px;
	}
	@media (min-width: 1400px) {
		height: 780px;
		max-height: 780px;
	}
`
export const HeroItemsContainer = styled.div`
	@media (min-width: 525px) {
		${tw`p-0`}
	}
	${tw`absolute flex flex-col w-full m-auto items-center justify-center h-full p-4`}
	top:0;
	left: 0;
	right: 0;

	.play,
	.pause {
		${tw`absolute cursor-pointer`}
		right: 10%;
		bottom: 10%;
	}

	.brandImage {
		width: 500px;
		height: auto;
		${tw`mb-8`}
	}

	@media (min-width: 325px) {
		#dolphin-logo {
			width: 120px;
			height: 70px;
		}
		.play,
		.pause {
			height: 30px;
			width: 30px;
			right: 5%;
			bottom: 8%;
		}
		.brandImage {
			width: 150px;
			height: auto;
			${tw`mb-1`}
		}
	}

	@media (min-width: 525px) {
		#dolphin-logo {
			width: 150px;
			height: 80px;
		}
		.play,
		.pause {
			height: 35px;
			width: 35px;
			right: 3%;
			bottom: 8%;
		}
		.brandImage {
			width: 350px;
			height: auto;
			${tw`mb-6`}
		}
	}

	@media (min-width: 768px) {
		#dolphin-logo {
			width: 250px;
			height: 150px;
		}
		.play,
		.pause {
			height: 50px;
			width: 50px;
			right: 5%;
			bottom: 5%;
		}
		.brandImage {
			width: 500px;
			height: auto;
			${tw`mb-8`}
		}
	}

	@media (min-width: 1024px) {
		#dolphin-logo {
			width: 300px;
			height: 200px;
		}
		.play,
		.pause {
			height: 50px;
			width: 50px;
			right: 5%;
		}
	}

	@media (min-width: 1280px) {
		#dolphin-logo {
			width: 400px;
			height: 250px;
		}
		.play,
		.pause {
			height: 70px;
			width: 70px;
			right: 10%;
		}
	}

	${tw`bg-cover bg-no-repeat bg-center`}
	@media (min-width: 1350px) {
		${tw`bg-bottom`}
		background-image: url(${({ sources }) => (sources ? sources[0].srcWebp : '')});
		background-image: url(${({ sources }) => (sources ? sources[0].src : '')});
	}
	@media (min-width: 768px) and (max-width: 1349px) {
		background-image: url(${({ sources }) => (sources ? sources[1].srcWebp : '')});
		background-image: url(${({ sources }) => (sources ? sources[1].src : '')});
	}
	@media (min-width: 325px) and (max-width: 767px) {
		background-image: url(${({ sources }) => (sources ? sources[2].srcWebp : '')});
		background-image: url(${({ sources }) => (sources ? sources[2].src : '')});
	}
`
export const Line = styled.div`
	@media (min-width: 525px) {
		${tw`w-24 mt-0 mb-4`}
	}
	${tw`w-24 md:w-32 lg:w-40 xl:w-48 my-2`}
`
export const HeroButtons = styled.div`
	@media (min-width: 525px) {
		${tw`flex-row mt-4`}
	}
	${tw`flex flex-col mt-2 lg:mt-8`}
`
export const HeroSeeAllLink = styled(Link)`
	@media (min-width: 525px) {
		${tw`mb-0 mr-2`}
	}
	${tw`border border-yellow-500 bg-yellow-500 hover:border-yellow-400 hover:bg-yellow-400 rounded mb-2 mr-0`}
`
export const HeroSeeAll = styled.button`
	${tw`font-display text-white uppercase text-white text-sm md:text-base py-1 md:py-4 px-8 leading-none`}
`
export const HeroBookLink = styled(Link)`
	${tw`border border-dolphin-gray rounded bg-white ml-0`}
	background-color: rgba(255,255,255, 0.5);
	&:hover {
		background-color: rgba(255, 255, 255, 1);
	}
`
export const HeroBook = styled.button`
	@media (min-width: 525px) {
		${tw`py-2`}
	}
	${tw`font-display text-dolphin-gray leading-none text-sm md:text-base uppercase py-1 md:py-4 px-8 w-full`}
`
export const Bold = tw.b`font-bold`
export const Heading1 = styled.h1`
	@media (min-width: 525px) {
		${tw`text-3xl`}
	}
	${tw`font-display text-white text-lg md:text-5xl xl:text-6xl text-center`}
	text-shadow: 10px 6px 12px rgba(0,0,0,.75);
`
export const BannerText = styled.p`
	@media (min-width: 525px) {
		${tw`block text-xl`}
	}
	${tw`font-display text-white hidden md:text-3xl xl:text-4xl`}
`

export const MainSection = styled.section`
	${tw`pt-12 w-full`}
	background-color: #e5e5e5;
`
export const ProductsContainer = tw.div`flex flex-col md:flex-row md:px-4 w-full xl:w-4/5 xl:w-11/12 xxxl:w-3/4 m-auto items-center justify-center`
export const Main = tw.div`w-full mb-16 md:mb-0`
export const ProductsInnerContainer = tw.div`flex flex-col flex-wrap justify-center flex-nowrap`
export const ItemDetails = styled.div`
	${tw`w-10/12 lg:w-8/12 xl:w-6/12 mx-auto`}
`
export const Continue = tw.button`w-full border-2 border-sky hover:border-sky bg-transparent hover:bg-sky hover:text-white text-sky py-2 px-6 rounded uppercase font-display`
export const NullText = tw.p`font-display text-dolphin-gray text-2xl bg-white p-8 w-full text-center`
export const MainItemContainer = tw.div`flex flex-col md:flex-row mb-0 md:mb-12 justify-center`
export const ItemContainer = styled.div`
	box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1),
		0 10px 10px -5px rgba(0, 0, 0, 0.04);
	${tw`w-11/12 md:w-full mx-auto mb-4 md:mb-0 md:mx-2 bg-white`}
`
export const ItemInnerContainer = tw.div`bg-white flex flex-col py-4 h-full md:flex-row justify-between w-11/12 lg:w-10/12 mx-auto`
export const ItemImageContainer = styled.div`
	max-height: 400px;
	${tw`flex items-center justify-center h-screen cursor-pointer md:w-6/12`}
	&:hover {
		img {
			opacity: 0.875;
		}
	}
	@media (min-width: 325px) {
		max-height: 180px;
	}

	@media (min-width: 525px) {
		max-height: 300px;
	}
	@media (min-width: 768px) {
		max-height: 220px;
	}
	@media (min-width: 1024px) {
		max-height: 300px;
	}
	@media (min-width: 1280px) {
		max-height: 350px;
	}
	@media (min-width: 1400px) {
		max-height: 400px;
	}
`
export const ItemImage = styled.picture`
	${tw`h-full flex`}

	> img {
		${tw`m-auto`}
		height: 95%;
		@media (max-width: 767px) {
			max-height: 300px;
			${tw`mx-auto h-full`}
		}
	}
`
export const DetailsContainer = styled.div`
	&.notAuto {
		${tw`my-4`}
	}
	${tw`w-11/12 md:w-10/12 mx-auto`}
`
export const ProductName = styled.h3`
	span {
		${tw`font-bold font-display`}
	}
	${tw`font-line text-center text-xl mt-4 mb-2`}
`
export const MainProductName = styled(ProductName)`
	${tw`md:text-3xl mt-0 mb-4`}
`
export const AddToCartContainer = styled.div`
	${tw`flex flex-col justify-center items-center w-10/12 lg:w-8/12 xl:w-6/12 mx-auto mb-2 mt-4`}

	> input {
		${tw`text-center font-display w-3/12 p-2 mr-2`}
		background-color: #eaeaea;

		&[type='number']::-webkit-outer-spin-button,
		&[type='number']::-webkit-inner-spin-button {
			-webkit-appearance: none;
			margin: 0;
		}

		&[type='number'] {
			-moz-appearance: textfield;
		}
	}
`
export const Price = tw.p`font-display font-bold text-lg mb-2`
export const Feature = tw.p`font-display text-gray-600 text-center text-sm`
export const MainFeature = styled(Feature)`
	${tw`md:text-base`}
`
export const SubItemContainer = styled(MainItemContainer)`
	${tw`flex-wrap justify-start`}
`
export const SubItemsContainer = styled.div`
	${({ wid }) => (wid ? tw`w-11/12 md:w-6/12` : tw`w-11/12 md:w-4/12`)};
	${tw`p-0 md:p-2 mb-4 mx-auto md:m-0`}
`
export const SubItemsInnerContainer = styled.div`
	&.notAuto {
		${tw`h-auto`}
	}
	box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1),
		0 10px 10px -5px rgba(0, 0, 0, 0.04);
	${tw`flex flex-col h-full`}
`
export const SubItemsDetails = styled.div`
	&.notAuto {
		${tw`h-auto`}
	}
	${tw`bg-white py-4 flex flex-col h-full`}
`
export const SubItemBtns = styled.div`
	&.notAuto {
		${tw`my-4`}
	}
	${tw`mt-auto`}
`
export const SubItemImageContainer = styled.div`
	max-height: 300px;
	${tw`flex items-center justify-center h-screen cursor-pointer`}
	&:hover {
		img {
			opacity: 0.875;
		}
	}
	@media (min-width: 325px) {
		max-height: 180px;
	}

	@media (min-width: 525px) {
		max-height: 300px;
	}

	@media (min-width: 768px) {
		max-height: 150px;
	}

	@media (min-width: 1024px) {
		max-height: 200px;
	}
	@media (min-width: 1280px) {
		max-height: 250px;
	}
	@media (min-width: 1400px) {
		max-height: 300px;
	}
`
export const SubItemAddToCartContainer = styled(AddToCartContainer)`
	${tw`w-10/12 md:w-full md:px-2 lg:px-0 lg:w-10/12 xl:w-8/12 xxl:w-7/12`}

	& >button {
		${tw`text-sm px-3`}
	}
`
export const SubItemDetails = styled(ItemDetails)`
	${tw`h-full block w-10/12 md:w-full md:px-2 lg:px-0 lg:w-10/12 xl:w-8/12 xxl:w-7/12 m-auto`}
`
export const TrialRequest = styled(Link)`
	${tw`w-10/12 lg:w-8/12 xl:w-6/12 mx-auto mt-4 mb-2`}
`
export const Request = tw.button`font-display w-full uppercase border-2 border-yellow-500 hover:border-yellow-400 bg-yellow-500 hover:bg-yellow-400 hover:text-dolphin-gray text-white py-2 px-6 rounded cursor-pointer`

export const SubTrialRequest = styled(Link)`
	${tw`block w-10/12 md:w-full md:px-2 lg:px-0 lg:w-10/12 xl:w-8/12 xxl:w-7/12 mx-auto mt-4 mb-2`}
`
export const Button = styled.button`
	${tw`font-display w-full uppercase border-2 border-yellow-500 hover:border-yellow-400 bg-yellow-500 hover:bg-yellow-400 hover:text-dolphin-gray text-white py-2 px-6 rounded cursor-pointer`}
	&[disabled] {
		${tw`cursor-not-allowed`}
	}
`

export const LineDescriptionContainer = styled.div`
	@media (min-width: 525px) {
		${tw`px-12`}
	}
	${tw`w-full flex flex-col py-8 px-8 md:py-12 md:px-20`}
`
export const Heading2 = styled.h2`
	@media (min-width: 525px) {
		${tw`text-2xl`}
	}
	${tw`w-full text-center text-blue-500 font-display text-xl md:text-4xl font-bold mb-6`}

	span {
		${tw`font-line`}
	}
`
export const Text = styled.p`
	@media (min-width: 525px) {
		${tw`text-lg`}
	}
	${tw`font-display text-base text-center mb-4`}
`

export const FaqSection = styled.section`
	${tw`flex flex-col w-full pb-10 items-center justify-center`}

	button {
		${tw`text-white`}
	}
`
export const FaqTitle = tw.h2`font-display text-white text-2xl bg-blue-500 text-center py-1 w-full`
export const FaqContainer = tw.div`flex flex-col m-auto py-12 w-11/12 md:w-9/12`
export const EnquireNow = styled(TrialRequest)``
export const Enquire = styled(Request)``
export const SubEnquire = styled(SubTrialRequest)``

export const MainDetailsContainer = tw.div`flex flex-col md:w-6/12 items-center justify-center`
export const FaqButton = styled(Link)`
	${tw`hover:bg-yellow-400 hover:text-white border-solid border-2 rounded cursor-pointer border-yellow-500 bg-yellow-500 hover:bg-yellow-400 hover:border-yellow-400 text-white px-12 py-2`}
`
export const FaqText = tw.p``

export const HeroBottomText = styled.h6`
	${tw`text-center text-xl mt-24 mb-2 text-white`}
`